var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsExportEnabled24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.092 3.25a.75.75 0 0 1 .546.246l3.415 3.756a.75.75 0 0 1-1.11 1.01l-2.11-2.322V16a.75.75 0 0 1-1.5 0V5.872L9.041 8.275a.75.75 0 0 1-1.085-1.036l3.585-3.757a.75.75 0 0 1 .551-.232ZM3.168 16.37a.75.75 0 0 1 .75.75v2.006c0 .62.503 1.124 1.124 1.124h13.916c.62 0 1.124-.503 1.124-1.124V17.12a.75.75 0 1 1 1.5 0v2.006a2.624 2.624 0 0 1-2.624 2.624H5.042a2.624 2.624 0 0 1-2.624-2.624V17.12a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsExportEnabled24);
export default __webpack_public_path__ + "static/media/actions-export-enabled-24.d86c9c958da111ff0bd21e3aecc2c501.svg";
export { ForwardRef as ReactComponent };